import React from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { MultiSelect } from 'primereact/multiselect';

import ErrorElement from "../../commonComponent/ErrorElement";
import { FormSubSections, ProgramContainer, RedirectSection } from "../../entities/formTemplateDataType";
import { buttonClassList, odsButtonClassList, SubmissionMethodList } from "../../entities/Constants";
import { generateSectionIndex, getParentSection, getParentSubSection } from "../../utilities/ElementUtils";
import { DialogBase, Props } from "./DialogBase";

interface State {
    pickedFieldOptions;
    statusCodeError?: string;
    statusCodeValue?: string;
    redirectPage?: RedirectSection;
}

export class DialogForButtonComponent extends DialogBase<Props,State> {
    popupMessageEditor;
    popupMessageFRAEditor;
    constructor(props: Props) {
        super(props);

        this.state = {
            pickedFieldOptions: [],
        };
    }

    componentDidMount(): void {
        if (this.props.ele.FilterField != null) {
            this.onChangeHanlder(this.props.ele.FilterField)
        }
    }

    onChangeHanlder = (newValue) => {
        this.props.ele.FilterField = newValue;
        let totalOption = [];
        let eleList = (this.props.ele.parent as FormSubSections).ListOfFormSectionElements.filter(p => p.Sequence < this.props.ele.Sequence)
        let pickedFieldOptions =  eleList.filter(
                    (ele) =>
                        this.props.isEng
                            ? ele.ENUTitle.replace(/\s/g, "") === newValue
                            : ele.FRATitle.replace(/\s/g, "") === newValue
                ).map((q) => {
                    const container = {};
                    container[
                        this.props.isEng
                            ? q.ENUTitle.replace(/\s/g, "")
                            : q.FRATitle.replace(/\s/g, "")
                    ] = q.ListOfLOVValues;
                    return container;
                });

                totalOption.push(...pickedFieldOptions);


        this.setState({ pickedFieldOptions: totalOption });
        this.props.callback();
    }

    handleStatusCodeChange = (e) => {
        const regex = /^[a-zA-Z0-9_-]+$/;
        const value = e.target.value as string;
        if (!value) {
            this.setState({ statusCodeError: "Status code is required" });
        } else if (!regex.test(value)) {
            this.setState({ statusCodeError: "Only alphanumeric is allowed" });
        } else {
            this.setState({ statusCodeError: undefined, statusCodeValue: value.trim() });
        }
    }

    addRoutingPage = (e) => {
        e.preventDefault();
        if (this.state.statusCodeValue && this.state.redirectPage?.redirectPage) {
            const statusCode = this.state.statusCodeValue?.trim();
            this.setState({statusCodeError: undefined});
            const route = this.state.redirectPage;
            route.statusCode = statusCode;
            this.props.ele.SubmitButton = this.props.ele.SubmitButton || {};
            this.props.ele.SubmitButton.apiSuccessRedirectPage = this.props.ele.SubmitButton.apiSuccessRedirectPage || [];
            this.props.ele.SubmitButton.apiSuccessRedirectPage.push(route);
            this.setState({statusCodeValue: undefined, redirectPage: undefined});
            this.props.callback();
        } else {
                this.setState({statusCodeError: "status code is required"});
        }
        
    }

    generateContentString = () => {
        let elementListWithOptions = [];
        const sectionIndex = generateSectionIndex(this.props.ele)

        let subSection = getParentSubSection(this.props.ele);
        let section = getParentSection(this.props.ele);
        let listOfSubSectionToDuplicate = section.ListOfFormSubSections.filter(sub => sub.ENUTitle && sub.Id != subSection.Id && sub.CanBeDuplicate).map(sub => sub.ENUTitle);
        const root=section.parent as ProgramContainer;
        let listOfSectionToDuplicate = Array.from(new Set(root.ListOfFormSections.filter(sec => sec.duplicateGroupID?.trim()).map(sec => sec.duplicateGroupID!.trim())
  )
);
        let list = subSection.ListOfFormSectionElements.filter(
            (q) =>
            (q.Datatype === "RadioButton" ||
                q.Datatype === "CheckGroup" ||
                q.Datatype === "Dropdown")
        ).map((q) => {
            return {
                code: this.props.isEng
                    ? q.ENUTitle?.replace(/\s/g, "")
                    : q.FRATitle?.replace(/\s/g, ""),
                description: this.props.isEng ? q.ENUTitle : q.FRATitle
            };
        });
        elementListWithOptions.push(...list);

        const valueArray = Array.isArray(this.props.ele.ClassName) ? this.props.ele.ClassName : [];

        let htmlString = [];
        htmlString.push(
            <div style={{ width: "100%", paddingTop: "5px" }}>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Custom Button Text (EN)</div>
                    <div style={{ width: '60%' }}>
                        <InputText
                            className="ontario-input"
                            key={"custom-button-text-en-" + this.props.ele.Sequence}
                            value={this.props.ele.CustomButtonText || ''}
                            placeholder="Leave empty to use default title"
                            onChange={(e) => {
                                this.props.ele.CustomButtonText = e.target.value || undefined;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Custom Button Text (FR)</div>
                    <div style={{ width: '60%' }}>
                        <InputText
                            className="ontario-input"
                            key={"custom-button-text-fr-" + this.props.ele.Sequence}
                            value={this.props.ele.CustomButtonTextFRA || ''}
                            placeholder="Leave empty to use default title"
                            onChange={(e) => {
                                this.props.ele.CustomButtonTextFRA = e.target.value || undefined;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ border: '1px solid #d6d6d6', padding: '12px', borderRadius: '4px', marginTop: '12px' }}>
                    <div style={{ fontWeight: 600, marginBottom: '8px' }}>Cancel button settings</div>
                    <div style={{ display: "flex", marginTop: '6px', marginBottom: '6px' }}>
                        <div style={{ width: '25%' }}>Is Cancel Button</div>
                        <div style={{ alignItems: 'center', marginTop: '5px' }}>
                            <Checkbox
                                checked={!!this.props.ele.IsCancelButton}
                                value={this.props.ele.IsCancelButton}
                                className='p-checkbox'
                                title="Redirect to URL after confirmation"
                                onChange={(e) => {
                                    this.props.ele.IsCancelButton = e.checked;
                                    if (e.checked) {
                                        this.props.ele.ShowPopup = true;
                                    }
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    {this.props.ele.IsCancelButton && (
                        <>
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Cancel Redirect URL (EN)</div>
                                <div style={{ width: '60%' }}>
                                    <InputText
                                        className="ontario-input"
                                        value={this.props.ele.CancelRedirectUrl || ''}
                                        onChange={(e) => {
                                            this.props.ele.CancelRedirectUrl = e.target.value || undefined;
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Cancel Redirect URL (FR)</div>
                                <div style={{ width: '60%' }}>
                                    <InputText
                                        className="ontario-input"
                                        value={this.props.ele.CancelRedirectUrlFRA || ''}
                                        onChange={(e) => {
                                            this.props.ele.CancelRedirectUrlFRA = e.target.value || undefined;
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ marginTop: '10px', color: '#4d4d4d', fontSize: '12px' }}>
                                Popup is automatically enabled for cancel buttons. Leave the URL empty to fallback to the ServiceOntario default.
                            </div>
                        </>
                    )}
                </div>

                <div style={{ border: '1px solid #d6d6d6', padding: '12px', borderRadius: '4px', marginTop: '12px' }}>
                    <div style={{ fontWeight: 600, marginBottom: '8px' }}>Save draft button settings</div>
                    <div style={{ display: "flex", marginTop: '6px', marginBottom: '6px' }}>
                        <div style={{ width: '25%' }}>Is Save Draft Button</div>
                        <div style={{ alignItems: 'center', marginTop: '5px' }}>
                            <Checkbox
                                checked={!!this.props.ele.IsSaveDraftButton}
                                value={this.props.ele.IsSaveDraftButton}
                                className='p-checkbox'
                                title="Mark as save draft to align with Continue"
                                onChange={(e) => {
                                    this.props.ele.IsSaveDraftButton = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ marginTop: '10px', color: '#4d4d4d', fontSize: '12px' }}>
                        Save draft buttons align beside the default Continue button when the section keeps Continue on the left.
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Field</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown style={{ width: '100%' }} showClear
                            options={elementListWithOptions}
                            className="ontario-dropdown-small"
                            optionLabel="description"
                            optionValue="code"
                            value={this.props.ele.FilterField?.replace(/\s/g, "")}
                            placeholder="Filtered by previous field"
                            onChange={(e) => {
                                this.onChangeHanlder(e.value);
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Value</div>
                    <div style={{ width: '60%', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Dropdown style={{ width: '100%' }} showClear
                            className="ontario-dropdown-small"
                            options={this.state.pickedFieldOptions[0] != null ? this.state.pickedFieldOptions[0][this.props.ele.FilterField] : null}
                            value={this.props.ele.FilterValue}
                            optionLabel="description"
                            optionValue="code"
                            placeholder="Filtering value"
                            onChange={(e) => {
                                this.props.ele.FilterValue = e.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                {this.stepperScriptHtml()}

                {this.initScriptHtml()}


                {this.scriptHtml()}

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Class(es)</div>
                    <div style={{ width: '60%' }}>
                        <MultiSelect key={"class_button_" + this.props.ele.Sequence}
                            options={buttonClassList}
                            optionLabel='label'
                            optionValue='val'
                            value={valueArray}
                            onChange={(e) => {
                                this.props.ele.ClassName = e.value;
                                this.props.callback();
                            }}></MultiSelect >
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Show Popup</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        <Checkbox 
                            checked={this.props.ele.ShowPopup || this.props.ele.PopupDialogConfigs?.ShowPopup} 
                            value={this.props.ele.ShowPopup || this.props.ele.PopupDialogConfigs?.ShowPopup}
                            className='p-checkbox' 
                            title="Show confirmation popup before action"
                            onChange={(e) => {
                                this.props.ele.ShowPopup = e.checked;
                                this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, ShowPopup: e.checked}
                                this.props.callback();
                            }} 
                        />
                    </div>
                </div>

                {(this.props.ele.ShowPopup && this.props.ele.IsCancelButton) && (
                    <>
                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Popup Title (EN)</div>
                            <div style={{ width: '60%' }}>
                                <InputText
                                    className="ontario-input"
                                    value={this.props.ele.PopupTitle || this.props.ele.PopupDialogConfigs?.PopupTitle || ''}
                                    onChange={(e) => {
                                        this.props.ele.PopupTitle = e.target.value || undefined;
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupTitle: e.target.value}
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Popup Title (FR)</div>
                            <div style={{ width: '60%' }}>
                                <InputText
                                    className="ontario-input"
                                    value={this.props.ele.PopupTitleFRA || this.props.ele.PopupDialogConfigs?.PopupTitleFRA || ''}
                                    onChange={(e) => {
                                        this.props.ele.PopupTitleFRA = e.target.value || undefined;
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupTitleFRA: e.target.value}
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Popup Title Icon</div>
                            <div style={{ width: '60%' }}>
                                <InputText
                                    className="ontario-input"
                                    value={this.props.ele.PopupDialogConfigs?.PopupMessageIcon || ''}
                                    onChange={(e) => {
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupTitleFRA: e.target.value}
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>
                       
                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Popup Message (EN)</div>
                            <div style={{ width: '60%' }}>
                              {this.popupMessageEditor && (                                
                                <Editor
                                    className="ontario-input ontario-margin-bottom-0-!"
                                    value={this.props.ele.PopupMessage || this.props.ele.PopupDialogConfigs?.PopupMessage || ''}
                                    onTextChange={(e) => {
                                        this.props.ele.PopupMessage = e.htmlValue;
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupMessage: e.htmlValue}
                                        this.props.callback();
                                    }}
                                />
                            )}
                            {!this.popupMessageEditor && (
                                <InputTextarea
                                    className="ontario-input"
                                    value={this.props.ele.PopupMessage || this.props.ele.PopupDialogConfigs?.PopupMessage || ''}
                                    onChange={(e) => {
                                        this.props.ele.PopupMessage = e.target.value;
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupMessage: e.target.value}
                                        this.props.callback();
                                    }}
                                />
                            )}                            
                             <button onClick={() => {
                                    this.popupMessageEditor = !this.popupMessageEditor;
                                    this.props.callback();
                                }}>
                                    {this.popupMessageEditor == true ? "Raw" : "HTML"}
                                </button>
                           </div>
                        </div>

                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Popup Message (FR)</div>
                            <div style={{ width: '60%' }}>
                              {this.popupMessageFRAEditor && (   
                                <Editor
                                    className="ontario-input ontario-margin-bottom-0-!"
                                    value={this.props.ele.PopupMessageFRA || ''}
                                    onTextChange={(e) => {
                                        this.props.ele.PopupMessageFRA = e.htmlValue;
                                        this.props.callback();
                                    }}
                                />
                              )}
                              {!this.popupMessageFRAEditor && (
                                <InputTextarea
                                    className="ontario-input"
                                    value={this.props.ele.PopupMessageFRA || this.props.ele.PopupDialogConfigs?.PopupMessageFRA || ''}
                                    onChange={(e) => {
                                        this.props.ele.PopupMessageFRA = e.target.value;
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupMessageFRA: e.target.value}
                                        this.props.callback();
                                    }}
                                />
                            )}                            
                             <button onClick={() => {
                                    this.popupMessageFRAEditor = !this.popupMessageFRAEditor;
                                    this.props.callback();
                                }}>
                                    {this.popupMessageFRAEditor == true ? "Raw" : "HTML"}
                                </button>
                          
                            </div>
                        </div>
                        
                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Left Button Class</div>
                            <div style={{ width: '60%' }}>
                                <Dropdown showClear options={odsButtonClassList} optionLabel='label' optionValue='val' value={this.props.ele.PopupDialogConfigs?.PopupLeftButtonClassName}
                                    onChange={(e) => {
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupLeftButtonClassName: e.target.value}
                                        this.props.callback();
                                    }}
                                ></Dropdown>
                            </div>
                        </div>
                        
                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Left Button Text (EN)</div>
                            <div style={{ width: '60%' }}>
                                <InputText
                                    className="ontario-input"
                                    value={this.props.ele.PopupSaveButtonText || this.props.ele.PopupDialogConfigs?.PopupLeftButtonText || ''}
                                    onChange={(e) => {
                                        this.props.ele.PopupSaveButtonText = e.target.value || undefined;
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupLeftButtonText: e.target.value}
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Left Button Text (FR)</div>
                            <div style={{ width: '60%' }}>
                                <InputText
                                    className="ontario-input"
                                    value={this.props.ele.PopupSaveButtonTextFRA || this.props.ele.PopupDialogConfigs?.PopupLeftButtonTextFRA || ''}
                                    onChange={(e) => {
                                        this.props.ele.PopupSaveButtonTextFRA = e.target.value || undefined;
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupLeftButtonTextFRA: e.target.value}
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>
                        
                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Right Button Class</div>
                            <div style={{ width: '60%' }}>
                                <Dropdown showClear options={odsButtonClassList} optionLabel='label' optionValue='val' value={this.props.ele.PopupDialogConfigs?.PopupRightButtonClassName}
                                    onChange={(e) => {
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupRightButtonClassName: e.target.value}
                                        this.props.callback();
                                    }}
                                ></Dropdown>
                            </div>
                        </div>

                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Right Button Text (EN)</div>
                            <div style={{ width: '60%' }}>
                                <InputText
                                    className="ontario-input"
                                    value={this.props.ele.PopupCancelButtonText || this.props.ele.PopupDialogConfigs?.PopupRightButtonText || ''}
                                    onChange={(e) => {
                                        this.props.ele.PopupCancelButtonText = e.target.value || undefined;
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupRightButtonText: e.target.value}
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>Right Button Text (FR)</div>
                            <div style={{ width: '60%' }}>
                                <InputText
                                    className="ontario-input"
                                    value={this.props.ele.PopupCancelButtonTextFRA || this.props.ele.PopupDialogConfigs?.PopupRightButtonTextFRA || ''}
                                    onChange={(e) => {
                                        this.props.ele.PopupCancelButtonTextFRA = e.target.value || undefined;
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupRightButtonTextFRA: e.target.value}
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                            <div style={{ width: '25%' }}>Modal dialog?</div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                <Checkbox 
                                    checked={this.props.ele.PopupDialogConfigs?.ModalDialog || false} 
                                    value={this.props.ele.PopupDialogConfigs?.ModalDialog}
                                    className='p-checkbox' 
                                    title="Is modal dialog"
                                    onChange={(e) => {
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, ModalDialog: e.checked}
                                        this.props.callback();
                                    }} 
                                />
                            </div>
                        </div>

                        <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                            <div style={{ width: '25%' }}>Closable?</div>
                            <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                <Checkbox 
                                    checked={this.props.ele.PopupDialogConfigs?.PopupCloseable || false} 
                                    value={this.props.ele.PopupDialogConfigs?.PopupCloseable}
                                    className='p-checkbox' 
                                    title="Popup is closable"
                                    onChange={(e) => {
                                        this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupCloseable: e.checked}
                                        this.props.callback();
                                    }} 
                                />
                            </div>
                        </div>
                    </>
                )}

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Inline (Styling):</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={this.props.ele.inlineStyling} value={this.props.ele.inlineStyling}
                            className='p-checkbox' title="Button is inline without line break"
                            onChange={(e) => {
                                this.props.ele.inlineStyling = e.checked;
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Button position:</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        <Dropdown style={{ width: '100%' }} showClear
                            className="ontario-dropdown-small"
                            options={this.buttonPositionOptions}
                            value={this.props.ele.Centered ? 'center' : this.props.ele.ButtonProps?.buttonPosition }
                            onChange={(e) => {
                                if (e.value === 'center') {
                                    this.props.ele.Centered = true;
                                } else {
                                    this.props.ele.Centered = null;
                                }
                                if (this.props.ele.ButtonProps) {
                                    this.props.ele.ButtonProps = {...this.props.ele.ButtonProps, buttonPosition: e.value}
                                } else {
                                    this.props.ele.ButtonProps = {buttonPosition: e.value}
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Section group to duplicate</div>
                    <div style={{ width: '15%' }}>
                        <Dropdown showClear key={"class_button_" + this.props.ele.Sequence}
                            options={listOfSectionToDuplicate}
                            value={this.props.ele.sectionGroupToDuplicate}
                            onChange={(e) => {
                                this.props.ele.sectionGroupToDuplicate = e.value;
                                this.props.ele.ValidateStep = 'N';
                                this.props.ele.SubmitButton = {
                                    ...(this.props.ele.SubmitButton ?? {}),
                                    ValidateStep: 'N'
                                };
                                this.props.callback();
                            }}
                        ></Dropdown>
                    </div>
                    <div style={{display: this.props.ele.sectionGroupToDuplicate ? "flex" : "none", marginLeft: '10px', width: '55%' }}>
                        <div style={{ marginLeft: '10px', width: '35%' }}>This is Delete Button:</div>
                        <div style={{ alignItems: 'left', marginTop: '0px', marginLeft: '5px' }}>
                            {/* @ts-ignore */}
                            <Checkbox checked={this.props.ele.isDeleteButton} value={this.props.ele.isDeleteButton}
                                className='p-checkbox' title="Is Delete Button"
                                onChange={(e) => {
                                    this.props.ele.isDeleteButton = e.checked;
                                    this.props.callback();
                                }} />
                        </div>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Subsection to duplicate</div>
                    <div style={{ width: '60%' }}>
                        <Dropdown showClear key={"class_button_" + this.props.ele.Sequence}
                            options={listOfSubSectionToDuplicate}
                            value={this.props.ele.SubSectionToDuplicate}
                            onChange={(e) => {
                                this.props.ele.SubSectionToDuplicate = e.value;
                                this.props.ele.ValidateStep = 'N';
                                this.props.ele.SubmitButton = {
                                    ...(this.props.ele.SubmitButton ?? {}),
                                    ValidateStep: 'N'
                                };
                                this.props.callback();
                            }}
                        ></Dropdown>
                    </div>
                </div>


                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Validate Step</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={this.props.ele.ValidateStep == 'Y' || this.props.ele.SubmitButton?.ValidateStep == 'Y'} value={this.props.ele.ValidateStep}
                            className='p-checkbox' title="Validate Step where button is"
                            onChange={(e) => {
                                this.props.ele.ValidateStep = e.checked ? 'Y' : 'N';
                                this.props.ele.SubmitButton = {...(this.props.ele.SubmitButton ?? {}), ValidateStep: e.checked ? 'Y' : 'N' };
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Enable Recaptcha</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={!!this.props.ele.Recaptcha || this.props.ele.SubmitButton?.enableRecaptcha} value={!!this.props.ele.Recaptcha}
                            className='p-checkbox' title="Enable Recaptcha"
                            onChange={(e) => {
                                this.props.ele.Recaptcha = e.checked ? {action: ''} : undefined;
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, enableRecaptcha: e.checked ? e.checked : false };
                                this.props.callback();
                            }} />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Enable Pagination: </div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={this.props.ele.SubmitButton?.enablePanignation} value={!!this.props.ele.SubmitButton?.enablePanignation}
                            className='p-checkbox' title="Enable pagination"
                            onChange={(e) => {
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, enablePanignation: e.checked ? e.checked : false };
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Inline Style</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <InputTextarea className="ontario-input" value={this.props.ele.InlineStyle}
                            onChange={(e) => {
                                this.props.ele.InlineStyle = e.target.value;
                                this.props.callback();
                            }}></InputTextarea></div>
                </div>
            

                { this.props.ele.Recaptcha && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Recaptcha action:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <InputText className="ontario-input" 
                                value={this.props.ele.Recaptcha.action || this.props.ele.SubmitButton?.recaptchaAction} 
                                onChange={(e) => {
                                    this.props.ele.Recaptcha.action = e.target.value;
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, recaptchaAction: e.target.value };
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>API</div>
                    <div style={{ width: '60%'}}>                  
                        <InputText className="ontario-input" 
                            value={this.props.ele.Api || this.props.ele.SubmitButton?.api} 
                            onChange={(e) => {
                                this.props.ele.Api = e.target.value;
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, api: e.target.value };
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                {(this.props.ele.Api || this.props.ele.SubmitButton?.api) && (this.props.ele.IsSaveDraftButton) && (<div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Save draft to database</div>
                    <div style={{ width: '10%'}}>                  
                        <Checkbox
                            checked={!!this.props.ele.SaveDraftToDatabase}
                            value={this.props.ele.SaveDraftToDatabase}
                            className='p-checkbox'
                            title="Save Draft to database"
                            onChange={(e) => {
                                this.props.ele.SaveDraftToDatabase = e.checked;
                                this.props.callback();
                            }}
                        />
                    </div>
                    <div style={{ width: '20%' }}>Success message element to display</div>
                    <div style={{ width: '30%'}}>                  
                        <InputText className="ontario-input" 
                            value={this.props.ele.SaveDraftToDatabaseSuccessMessageElement} 
                            title="LoadBindName of message element"
                            onChange={(e) => {
                                this.props.ele.SaveDraftToDatabaseSuccessMessageElement = e.target.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>)}
                {(this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>API-Key:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <div >
                                <InputText className="ontario-input"
                                    value={this.props.ele.SubmitButton?.apiKeyKey}
                                    placeholder="Key"
                                    title="API-Key Key"
                                    onChange={(e) => {
                                        this.props.ele.ApiKeyKey = e.target.value;
                                        this.props.ele.SubmitButton = { ...this.props.ele.SubmitButton ?? {}, apiKeyKey: e.target.value };
                                        this.props.callback();
                                    }}
                                />
                            </div>
                            <div>
                                <InputText className="ontario-input"
                                    value={this.props.ele.SubmitButton?.apiKeyValue}
                                    placeholder="Value"
                                    title="API-Key Value"
                                    onChange={(e) => {
                                        this.props.ele.ApiKeyValue = e.target.value;
                                        this.props.ele.SubmitButton = { ...this.props.ele.SubmitButton ?? {}, apiKeyValue: e.target.value };
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {(this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Method</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            {/* @ts-ignore */}
                            <Dropdown style={{ width: '100%' }} showClear
                                className="ontario-dropdown-small"
                                options={SubmissionMethodList}
                                value={this.props.ele.SubmissionMethod || this.props.ele.SubmitButton?.SubmissionMethod}
                                optionLabel='label'
                                optionValue='val'
                                placeholder="SubmissionMethod"
                                onChange={(e) => {
                                    this.props.ele.SubmissionMethod = e.value;
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, SubmissionMethod: e.value };
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
                {(this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Response field name:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <InputText className="ontario-input"
                                value={this.props.ele.SubmitButton?.responseDataName}
                                onChange={(e) => {
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, responseDataName: e.target.value };
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
                { (this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>API error redirect to:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            {/* @ts-ignore */}
                            <Dropdown style={{ width: '100%' }} showClear
                                className="ontario-dropdown-small"
                                options={sectionIndex}
                                value={this.props.ele.SubmitButton?.apiErrorRedirectPage}
                                optionLabel='title'
                                optionValue='sequence'
                                placeholder="Page to redirect to"
                                onChange={(e) => {
                                    const sequence = Number(e.value);
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, apiErrorRedirectPage: isNaN(sequence) ? undefined : sequence};
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
                { (this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Max API attempts:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <InputText className="ontario-input"
                                type="number"
                                min="1"
                                max="10"
                                value={String(this.props.ele.SubmitButton?.maxApiAttempts || '')}
                                onChange={(e) => {
                                    const attempts = Number(e.target.value);
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, maxApiAttempts: isNaN(attempts) || attempts < 1 ? 1 : attempts};
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
                { (this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>Only send metadata for attachment</div>
                        <div style={{ alignItems: 'center', marginTop: '5px' }}>
                            <Checkbox
                                checked={!!this.props.ele.SubmitButton?.sendMetadataOnly}
                                value={this.props.ele.SubmitButton?.sendMetadataOnly}
                                className='p-checkbox'
                                title="Send placeholder instead of actual file data"
                                onChange={(e) => {
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, sendMetadataOnly: e.checked};
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
                { (this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>API success routes:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <div style={{ width: '100%', marginTop: '5px' }}>
                                {this.props.ele.SubmitButton?.apiSuccessRedirectPage?.length > 0 && (
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            {this.props.ele.SubmitButton?.apiSuccessRedirectPage?.map((item, index) => {
                                                return (
                                                    <tr key={`success-routing-${index}`}>
                                                        <td style={{ width: '20%' }}>
                                                            {item.statusCode}
                                                        </td>
                                                        <td style={{ width: '50%' }}>
                                                            {item.title}
                                                        </td>
                                                        <td style={{ width: '30%' }}>
                                                            <Button label="Delete" icon="pi pi-times" onClick={(e) => {
                                                                e.preventDefault();
                                                                this.props.ele.SubmitButton.apiSuccessRedirectPage.splice(index, 1);
                                                                this.props.callback();
                                                            }} />
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                )}
                                
                            </div>
                            <ErrorElement
                                display={!!this.state.statusCodeError}
                                message={this.state.statusCodeError}
                            />
                            <div style={{ width: '100%', marginTop: '5px', display: 'flex', justifyContent: 'space-between' }}>
                                <>
                                    <InputText className="ontario-input"
                                        style={{ width: '20%' }}
                                        value={this.state.statusCodeValue || ''}
                                        maxLength={10}
                                        placeholder="Status code"
                                        onChange={this.handleStatusCodeChange}
                                    />
                                    
                                    {/* @ts-ignore */}
                                    <Dropdown style={{ width: '50%' }} showClear
                                        className="ontario-dropdown-small"
                                        options={sectionIndex}
                                        value={this.state.redirectPage?.redirectPage}
                                        optionLabel='title'
                                        optionValue='sequence'
                                        placeholder="Page to redirect to"
                                        onChange={(e) => {
                                            const sequence = Number(e.value)
                                            const section = sectionIndex?.filter(p => p.sequence === sequence)[0];
                                            this.setState({redirectPage: { redirectPage: isNaN(sequence) ? undefined : sequence, title: section.title, statusCode: this.state.statusCodeValue ? this.state.statusCodeValue.trim() : undefined }});
                                            this.props.callback();
                                        }}
                                    />
                                    <Button style={{width: '30%'}} label="Add" onClick={(e) => {this.addRoutingPage(e)}} />
                                </>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );

        return htmlString;
    };

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Button properties for " + this.props.ele.ENUTitle : "Section properties for" + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.generateContentString()}
                </Dialog>
            </>
        );
        return html;
    }


    render() {

        return (
            <>
                {this.generateHtmlString()}
            </>
        );
    }
}
